module.exports = __webpack_public_path__ + "img/hikari_tairitsu_reunion_awaken.c25f5954.png";